import { styled } from 'styled-components';
import { device } from 'commons';

export const Main = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 48px 8px;
  overflow-y: auto;
  overflow-x: hidden;

  .positive {
    color: ${({ theme }) => theme.success_300};
  }

  .negative {
    color: ${({ theme }) => theme.danger_500};
  }

  @media (max-width: ${device.tablet}px) {
    padding: 32px 28px 8px;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BigNumbersWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
  }
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 1;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  min-height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
